import { Button } from "@circleco/compass/components/Button";
import { TextInput } from "@circleco/compass/components/TextInput";
import { Typography } from "@circleco/compass/components/Typography";
import type { ChangeEvent, MouseEvent } from "react";

import { t } from "@/i18n-js/instance";

import { ImageError } from "./ImageError";

export interface EmbedUploadProps {
  addEmbed: (event: MouseEvent<HTMLButtonElement>) => void;
  embedUrl?: string;
  imageError?: string;
  onChangeEmbedUrl: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const EmbedUpload = ({
  addEmbed,
  embedUrl,
  imageError,
  onChangeEmbedUrl,
}: EmbedUploadProps) => (
  <div className="flex flex-col gap-4">
    <ImageError error={imageError} />
    <TextInput
      value={embedUrl}
      placeholder={t("image_upload.paste_image_file")}
      onChange={onChangeEmbedUrl}
    />
    <div className="flex w-full flex-row justify-center">
      <Button
        variant="primary"
        size="lg"
        disabled={!embedUrl}
        onClick={addEmbed}
      >
        {t("image_upload.embed_image")}
      </Button>
    </div>
    <Typography variant="body-sm" color="tertiary" className="text-center">
      {t("image_upload.works_with_image_type")}
    </Typography>
  </div>
);
